import * as React from 'react';
import * as ReactTimeAgo from 'react-timeago';
import {addSeconds} from 'date-fns';
import {TimeAgoProps} from './types';

// tslint:disable-next-line:no-any
const _TimeAgo = (ReactTimeAgo as any).default;

export default class TimeAgo extends React.Component<TimeAgoProps, {}> {
  public static defaultProps = {
    momentLengthInSeconds: 60,
    momentString: 'moments ago'
  };

  public render() {
    const {date, momentLengthInSeconds, momentString, ...restProps} = this.props;
    return addSeconds(date, momentLengthInSeconds!) <= new Date() ? (
      <_TimeAgo date={date} {...restProps} />
    ) : (
      momentString
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TimeAgo/TimeAgo.tsx